/**
 * 
 * key
 * 
 */


const key = 'c2VydmljZV9sZXZlbF9zdGF0dXM='

export default key 